import moment from 'moment-timezone';

export interface Timezone {
  value: string;
  label: string;
  offset: number;
  abbrev: string;
  altName: string;
}
  
export function getTimezones(): Timezone[] {
  const timezones: Timezone[] = [];
  moment.tz.names().forEach(zoneName => {
    const offset = moment.tz(zoneName).utcOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? '+' : '-';
    const labelOffset = `GMT${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    const abbrev = moment.tz(zoneName).format('z');
    const altName = moment.tz(zoneName).format('zz');
  
    timezones.push( {
      value: zoneName,
      label: `(${labelOffset}) ${zoneName}`,
      offset: offset / 60,
      abbrev,
      altName
    });
  });
  
  return timezones.sort((a, b) => a.offset - b.offset);
}

export const getCurrentTimezone = (): Timezone => {
  return getTimezone(moment.tz.guess() as string);
};

export const getTimezone = (tZone: string | Timezone) => {
  let timezone: string;
  if (typeof tZone !== 'string') {
    timezone = tZone.value;
  } else {
    timezone = tZone as string;
  }
  const offset = moment.tz(timezone).utcOffset();
  const hours = Math.floor(Math.abs(offset) / 60);
  const minutes = Math.abs(offset) % 60;
  const sign = offset >= 0 ? '+' : '-';
  const labelOffset = `GMT${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  const abbrev = moment.tz(timezone).format('z');
  const altName = moment.tz(timezone).format('zz');
  const label = `(${labelOffset}) ${timezone}`;

  return {
    value: timezone,
    label: label,
    offset: offset / 60,
    abbrev: abbrev,
    altName: altName
  };
};
